import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const WhiteCardsContainer = styled.div`
  height: calc(100% - 40px);

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  overflow: auto;
  padding: 24px 0;
`;

export const ButtonWithLabel = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const TimePickerWithButton = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-flow: wrap;
`;

export const ButtonLabel = styled.div`
  font: ${(props) => props.theme.fonts.textMiddleNormal};
  color: ${(props) => props.theme.colors.greys.darker};
`;

export default {
  Container,
  WhiteCardsContainer,
  ButtonWithLabel,
  ButtonLabel,
};
